import React, { Component } from 'react'
import trans from "trans"
import {
    updateInputValue as change,
} from "app/reducers/form";

import { GridCell, Button, Spinner, Select, Range, Grid, Icon } from "@bdfx/mergado-ui-kit"

import { PreviewImageType, StyledGrid } from "./project-settings";
import SectionLoader from "app/components/section-loader";
import { SettingsFormType } from 'app/types/model-types';
import { connect } from 'react-redux';
import { ALL_OUTPUT_FORMATS_WITHOUT_GIF } from 'shape-edit/forms/helpers';
import { COMPRESSIBLE_FORMATS } from 'shape-edit/forms/helpers';
import { selectFormValues } from 'app/reducers/form';

interface Props {
    change: typeof change
    settingsForm: SettingsFormType
    originalContentLength: number
    originalFormat: string
    originalCompression: number
    previewImage: PreviewImageType
    refreshNow: Function
    refreshDebounced: Function
    close: Function
}


class SettingsModalWrapper extends Component<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        const { originalContentLength, originalFormat, originalCompression, previewImage, settingsForm } = this.props

        if (!previewImage) {
            return (<SectionLoader />)
        }

        const lessThanOriginal = previewImage.contentLength && originalContentLength ? ((originalContentLength - previewImage.contentLength) * 100 / originalContentLength).toFixed(0) : null

        const { template, width, height, contentLength, image } = previewImage

        return (
            <div>
                <StyledGrid gap={"5px"}>
                    <GridCell className={'image'}>
                        <img src={image} className={'main-image'} />
                    </GridCell>
                    <GridCell className={'settings'}>
                        <Grid cols={'auto auto'} gap={'10px'}>
                            <GridCell className={'label'}>{trans('output_image_format')}:</GridCell>
                            <GridCell>
                                <Select
                                    name={'settingsForm.output_image_format'}
                                    options={ALL_OUTPUT_FORMATS_WITHOUT_GIF.map(outputFromat => ({ value: outputFromat, label: outputFromat }))}
                                    onChange={() => {
                                        this.props.refreshDebounced(this.props.close)
                                    }}
                                />
                            </GridCell>

                            {COMPRESSIBLE_FORMATS.includes(settingsForm.output_image_format) &&
                                <React.Fragment>
                                    <GridCell className={'label'}>{trans('output_image_compression')}:</GridCell>
                                    <GridCell>
                                        <Range
                                            name={'settingsForm.output_image_compression'}
                                            min={10}
                                            max={100}
                                            step={5}
                                            onChange={() => {
                                                this.props.refreshDebounced(this.props.close)
                                            }}
                                        />
                                    </GridCell>
                                </React.Fragment>
                            }

                            <GridCell className={'label'}>{trans('template_name')}:</GridCell>
                            <GridCell>{template}</GridCell>

                            <GridCell className={'label'}>{trans('size_format')}:</GridCell>
                            <GridCell>{width} x {height}</GridCell>

                            <GridCell className={'label'}>{trans('output_image_content_length')}</GridCell>
                            <GridCell>{contentLength} kB</GridCell>

                            {originalContentLength && contentLength !== originalContentLength &&
                                <>
                                    <GridCell className={'label'}>{trans('original_output_image_content_length')}</GridCell>
                                    <GridCell> {originalContentLength} kB, {originalFormat}{originalFormat === 'jpeg' && ', ' + originalCompression}</GridCell>
                                </>
                            }

                            <GridCell className={'label'}>{lessThanOriginal ? trans('less_than_original') : trans('more_than_original')} {trans('about')} </GridCell>
                            <GridCell>{lessThanOriginal} %</GridCell>

                            <GridCell>&nbsp;</GridCell>
                            <GridCell />

                            <GridCell />
                            <GridCell className={'right'}>
                                <Button
                                    type={'void'}
                                    size={'small'}
                                    icon={<Icon type={'refresh'} text={trans('random_product')} />}
                                    onClick={() => this.props.refreshNow(true, true)}
                                />
                            </GridCell>
                        </Grid>
                    </GridCell>
                </StyledGrid>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state,'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(SettingsModalWrapper)